module.exports = __webpack_public_path__ + "img/tires.ef669da8.svg";